import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

/* eslint-disable no-param-reassign */
const disableSecuritySelectionCell = (cell: ICell, securityName?: string | null) => {
  cell.readOnly = true;

  const trimmedSecurityName = securityName?.trim();
  const securityLabel = trimmedSecurityName ? `[[b]]${trimmedSecurityName}[[/b]]` : '';

  const tooltip = `Security ${securityLabel} can't be changed with existing ownership. Delete this column to add ownership for a different security`;

  cell.tooltipMessages = [
    tooltip,
  ];
  cell.tooltipPlacement = 'bottom';
};

export default disableSecuritySelectionCell;
